import React from 'react';
import { Typography, Link, Card, CardContent, Container } from '@mui/material';
import { styled } from '@mui/material/styles';

// Custom styled blockquote
const CustomCard = styled(Card)(({ theme }) => ({
    marginBottom: theme.spacing(2),
    textAlign: 'left',
}));

const Title = styled(Typography)(({ theme }) => ({
    textAlign: 'center',
    marginBottom: theme.spacing(2),
}));

const Imprint = () => {
    return (
        <Container maxWidth={false} >
            <div style={{marginTop: '50px'}}>
                <CustomCard>
                    <CardContent>
                        <Title variant="h5" component="p" style={{ textAlign: 'left' }}>
                            Impressum
                        </Title>
                    </CardContent>
                </CustomCard>

                <CustomCard>
                    <CardContent>
                        <Typography variant="subtitle2" component="p" gutterBottom>
                            Der <b>Demonstrator »LLM Insight Expert« </b>ist eine Plattform des Fraunhofer-Instituts für Intelligente Analyse- und Informationssysteme IAIS, Schloss Birlinghoven 1, 53757 Sankt Augustin.
                        </Typography>
                    </CardContent>
                </CustomCard>

                <CustomCard>
                    <CardContent>
                        <Typography variant="subtitle2" component="p" gutterBottom>
                            <b>Anbieter der Webpräsenz des Demonstrators »llm-insight-expert« Nordrhein-Westfalen:</b>
                        </Typography>
                        <br />
                        <Typography variant="body2" component="p" gutterBottom>
                            Fraunhofer-Gesellschaft zur Förderung der angewandten Forschung e.V. <br />
                        </Typography>
                        <br />
                        <Typography variant="subtitle1" component="p" gutterBottom>
                            Hansastraße 27c, 80686 München
                            <br />
                            Telefon: <Link href="tel:+498912050" aria-label="Telefonnummer">+49 89 1205 – 0</Link> <br />
                            Fax: <Link href="tel:+498912057531" aria-label="Faxnummer">+49 89 1205-7531</Link> <br />
                            <Link href="mailto:info@zv.fraunhofer.de" aria-label="Email">info@zv.fraunhofer.de</Link> <br />
                            Umsatzsteuer-Identifikationsnummer gemäß § 27 a 
                            <br />
                            Umsatzsteuergesetz: DE 129515865
                        </Typography>
                    </CardContent>
                </CustomCard>

                <CustomCard>
                    <CardContent>
                        <Typography variant="subtitle2" component="p" gutterBottom>
                            <b>Registergericht</b>
                        </Typography>
                        <br />
                        <Typography variant="body2" component="p" gutterBottom>
                            Amtsgericht München <br />
                            Eingetragener Verein <br />
                            Register-Nr. VR 4461
                        </Typography>
                    </CardContent>
                </CustomCard>

                <CustomCard>
                    <CardContent>
                        <Typography variant="subtitle2" component="p" gutterBottom>
                            <b>Vertreten durch den Vorstand</b>
                        </Typography>
                        <br />
                        <Typography variant="body2" component="p" gutterBottom>
                            <b>Prof. Dr.-Ing. Holger Hanselka</b> | Präsident <br />
                            <br />
                            <b>Prof. Dr. Constantin Häfner</b> | Mitglied des Vorstands<br />
                            <br />
                            <b>Prof. Dr. Axel Müller-Groeling</b> | Mitglied des Vorstands<br />
                            <br />
                            <b>Elisabeth Ewen</b> | Mitglied des Vorstands <br />
                            <br />
                            <b>Dr. Sandra Krey</b> | Mitglied des Vorstands
                        </Typography>
                    </CardContent>
                </CustomCard>

                <CustomCard>
                    <CardContent>
                        <Typography variant="subtitle2" component="p" gutterBottom>
                        <b>Redaktionsverantwortlich für die Webpräsenz der Kompetenzplattform Künstliche Intelligenz Nordrhein-Westfalen im Sinne des Presserechts:</b>
                        </Typography>
                        <br></br>
                        <Typography variant="body2" component="p" gutterBottom>
                            Katrin Berkler <br />
                            Leiterin Presse und Öffentlichkeitsarbeit <br />
                            
                            <br />

                            Silke Loh <br />
                            Stv. Leiterin Presse und Öffentlichkeitsarbeit <br />
                            <br />
                            E-Mail: <Link href="mailto:pr@iais.fraunhofer.de" aria-label="Email für Pressekontakt">pr@iais.fraunhofer.de</Link>
                        </Typography>
                    </CardContent>
                </CustomCard>
            </div>
        </Container>
    );
}

export default Imprint;
